// Copyright (c) 2016 Deere & Company

import { dateComparator } from '../services/date-comparator';

export default Object.freeze({
    clearButton: true,
    comparator: dateComparator,
    inRangeInclusive: true,
    nullComparator: {
        equals: false,
        greaterThan: false,
        lessThan: false,
    },
    filterOptions: ['greaterThan', 'lessThan', 'inRange'],
    browserDatePicker: true,
    suppressAndOrCondition: true,
});
